import React, { Component } from "react";
import apiClient from "../lib/apiClient";

class PublicRanking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: "",
      songs: [],
      isLoading: true,
      countdown : 0,
      gigLength: 0,
      publicVotes: 0,
      songsToDisplay: []
    }
  }

  compare =  (a,b) => {
    if ( a.votes.length > b.votes.length ){
      return -1;
    }
    if ( a.votes.length < b.votes.length ){
      return 1;
    }
    return 0;
  }

  timer = () => {
    location.reload();
  }

  async componentDidMount() {
    this.countdown = setTimeout(this.timer, 30000);
    const songs = await apiClient.getGigSongs();
    let maxVotesCount = 0;
    let othersVotesCount = 0;
    [...songs].map(song => song.votes.map(vote => {
      if (vote.username === 'Max') {
        return maxVotesCount++;
      } 
      return othersVotesCount++;
    }));
    if (this.props.match.path.split("/")[1].length > 1) {
      if (othersVotesCount === 0) {
        this.setState({ songs, songsToDisplay: songs, isLoading: false, lang: this.props.match.path.split("/")[1], gigLength: maxVotesCount, publicVotes: othersVotesCount })
      } else {
        const songsToDisplay = [...songs].sort(this.compare);
        this.setState({ songs, songsToDisplay, isLoading: false, lang: this.props.match.path.split("/")[1], gigLength: maxVotesCount, publicVotes: othersVotesCount })
      }
    } else {
      this.setState({ songs, isLoading: false, lang: "en" })
    }
  }
  
  render() {
    const { lang, isLoading, gigLength, songsToDisplay } = this.state;

    const songs = songsToDisplay.splice(0, gigLength);
    
    const upcoming = {
      cat: "Properes cançons",
      cas: "Próximas canciones",
      en: "Upcoming songs",
      fr: "Chansons à venir",
      de: "Kommende Lieder" 
    }
    
    const done = {
      cat: "Cançons tocades",
      cas: "Canciones tocadas",
      en: "Played songs",
      fr: "Chansons jouées",
      de: "Lieder gespielt"
    }
    
    const votecount = {
      cat: "vots",
      cas: "votos",
      en: "votes",
      fr: "voix",
      de: "stimmen"
    }
    
    const ranking = {
      cat: "Ranking en directe!",
      cas: "Ranking en directo!",
      en: "Live ranking!",
      fr: "Classement en direct!",
      de: "Live-Ranking!"
    }
    
    const tagUs = {
      cat: "Etiqueta'ns a instagram!",
      cas: "Etiquétanos en Instagram!",
      en: "Tag us on Instagram!",
      fr: "Tag nous sur instagram!",
      de: "Markiere uns auf Instagram!"
    }
    
    
    if (isLoading) {
      <p className="main h-2/3">Loading...</p>
    }
    
    return (
      <div className="main min-h-2/3 h-auto pb-5">
        <p className="text-3xl w-80 mx-auto py-5">{ranking[lang]}</p>

        <div className="w-80 mx-auto">
          <p className="font-bold pt-5">{upcoming[lang]}</p>
          <hr className="border border-gray-700 my-3"/>
          {songs.map((song, index) => {
            const { artist, name, votes, played } = song;
            if (!played) {
                return <div className="flex justify-between w-80 text-left" key={index}>
                  <p>{ artist} - {name} ({votes.length} {votecount[lang]})</p>
                  </div>
            } else {
              return ""
            }
          })}

          <p className="font-bold text-red-400 pt-10">{done[lang]}</p>
          <hr className="border border-red-300 my-3"/>
          {songs.map((song, index) => {
            const { artist, name, votes } = song;
            if (song.played) {
              return <div className="flex justify-between" key={index}>
                <p className="text-red-400">{artist} - {name} ({votes.length} {votecount[lang]})</p>
                  </div>
            } else {
              return "";
              }
          })}
        </div>
        <div className="flex">
          <div className="flex flex-col text-xs items-baseline pt-10 mx-auto">
            <p className="text-xxs">{tagUs[lang]}</p>
          <div className="flex justify-center pb-10 items-center text-xs">
            <>
              <a href="https://www.instagram.com/max_and_sax/" target="_blank" rel="noreferrer" className="w-4 mr-1"><img src="../Instagram_logo_2016.svg.png" alt="instagram logo" /></a>
                <a href="https://www.instagram.com/max_and_sax/" target="_blank" rel="noreferrer">@max_and_sax</a>
            </>
              <p className="px-6"> | </p>
              <p>maxandsaxmusic@gmail.com</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PublicRanking;